import { render, staticRenderFns } from "./AddFund.vue?vue&type=template&id=27fa1a75&scoped=true"
import script from "./AddFund.vue?vue&type=script&lang=js"
export * from "./AddFund.vue?vue&type=script&lang=js"
import style0 from "./AddFund.vue?vue&type=style&index=0&id=27fa1a75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa1a75",
  null
  
)

export default component.exports